<section class="hero">
  <div class="hero-text">
    <span class="desktop-text">
      <span class="highlight"> {{ "home.hero.highlight" | translate }} </span>
      <span class="text-thin"
        >{{ "home.hero.text1" | translate }}<br />
        {{ "home.hero.text2" | translate }}</span
      ><br />
      <span class="captional-text">{{ "home.hero.text3" | translate }}</span>
    </span>
    <hr />
    <div class="hero-image-mobile">
      <img src="assets/figury1_a.png" c />
    </div>
    <p>
      {{ "home.hero.text4" | translate }} <span class="rectangle"></span>
      {{ "home.hero.text5" | translate }} <span class="rectangle"></span>
      {{ "home.hero.text6" | translate }}
    </p>
    <button
      routerLink="/offers"
      routerLinkActive="active"
      class="hero-btn-offers"
      href="#oferty"
    >
      {{ "home.hero.button" | translate }} →
    </button>
  </div>

  <div
    (mouseenter)="changeImg = true"
    (mouseleave)="changeImg = false"
    class="hero-image"
  >
    <img src="assets/figury.png" class="img-scroll" />

    <img
      [@fadeIn]="changeImg == true"
      src="assets/figury1_a.png"
      class="img-scroll-hover"
    />
  </div>
</section>

<section class="partnership-container">
  <article>
    <div class="partner-row">
      <div class="partner-text">
        <div class="mobile-element"></div>
        <h2>
          {{ "home.partners.title" | translate }}
          <hr />
        </h2>
      </div>
      <div class="partner-logos">
        <div class="logo-container">
          <img
            src="assets/orange.png"
            class="partners-img"
            id="oragne-mobile"
            alt="Orange"
          />
          <p class="logo-text">
            {{ "home.partners.partner1" | translate }}
          </p>
        </div>
        <div class="logo-container">
          <img src="assets/mswia.png" class="partners-img" alt="MSWiA" />
          <p class="logo-text">
            {{ "home.partners.partner2" | translate }}
          </p>
        </div>
        <div class="logo-container">
          <img
            src="assets/poczta.png"
            class="partners-img"
            alt="Poczta Polska"
          />
          <p class="logo-text">{{ "home.partners.partner3" | translate }}</p>
        </div>
        <div class="logo-container">
          <img src="assets/tauron.png" class="partners-img" alt="tuatara" />
          <p class="logo-text">{{ "home.partners.partner4" | translate }}</p>
        </div>
      </div>
    </div>
  </article>
  <button
    routerLink="/references"
    routerLinkActive="active"
    class="btn-partnership"
    id="btn-partners"
  >
    {{ "home.partners.button" | translate }} →
  </button>
</section>

<section class="about-us">
  <article>
    <div class="experts-text">
      <div class="mobile-element"></div>
      <h2>
        {{ "home.about.title" | translate }}
        <hr />
      </h2>
    </div>
    <div class="experts-description-text">
      <p>
        <span class="experst-caption-bold-text">{{
          "home.about.subtitle1" | translate
        }}</span
        ><br />
        {{ "home.about.text1" | translate }}<br />
        {{ "home.about.text2" | translate }}
      </p>
      <p>
        <span class="experst-caption-bold-text">{{
          "home.about.subtitle2" | translate
        }}</span
        ><br />
        {{ "home.about.text3" | translate }}<br />
        {{ "home.about.text4" | translate }}
      </p>
    </div>
    <button
      routerLink="/about"
      routerLinkActive="active"
      class="experts-btn"
      id="btn-get-to-know"
    >
      {{ "home.about.button" | translate }} →
    </button>
  </article>

  <section class="exp-elements">
    <div class="col-elements">
      <div class="first-element"></div>
      <div id="element-anim" class="second-element"></div>
    </div>
    <div class="row-elements">
      <div class="third-element"></div>
      <div class="fourth-element"></div>
    </div>
  </section>
</section>

<section class="our-ekologic">
  <div class="test">
    <aside></aside>
    <article></article>
  </div>
  <div class="parent">
    <div class="div1">
      <div class="mobile-ele">{{ "home.numbers.title" | translate }}</div>
      <hr />
    </div>

    <div class="div2"><div class="mob-ele">14</div></div>
    <div class="div3">
      <div class="mob-ele">{{ "home.numbers.text1" | translate }}</div>
    </div>
    <div class="div4">25+</div>
    <div class="div5">{{ "home.numbers.text2" | translate }}</div>
    <div class="div6"><div class="mob-ele">2</div></div>
    <div class="div7">
      <div class="mob-ele">{{ "home.numbers.text3" | translate }}</div>
    </div>
    <div class="div8">+100</div>
    <div class="div9">{{ "home.numbers.text4" | translate }}</div>
  </div>
</section>

<section class="popular-offers" id="oferty">
  <main>
    <div class="offerts-text">
      <div class="mobile-element" id="offerts-mob-ele"></div>
      <h2>{{ "home.offer.title" | translate }}</h2>
      <hr />
    </div>
    <div class="offerts-container">
      <div class="offerts">
        <div class="offer first-offert">
          <button
            routerLink="/offers"
            routerLinkActive="active"
            class="first-offer-btn"
          >
            <h3>
              {{ "home.offer.first1" | translate }}<br />{{
                "home.offer.first2" | translate
              }}<br />{{ "home.offer.first3" | translate }}<br />
            </h3>
            <p>{{ "home.offer.button" | translate }} →</p>
          </button>
        </div>

        <div class="offer second-offert">
          <button
            routerLink="/offers"
            routerLinkActive="active"
            class="second-offer-btn"
          >
            <h3>
              {{ "home.offer.second1" | translate }}<br />{{
                "home.offer.second2" | translate
              }}<br />{{ "home.offer.second3" | translate }}<br />
            </h3>
            <p>{{ "home.offer.button" | translate }} →</p>
          </button>
        </div>
        <div class="offer third-offert">
          <button
            routerLink="/offers"
            routerLinkActive="active"
            class="third-offer-btn"
          >
            <h3>
              {{ "home.offer.third1" | translate }}<br />{{
                "home.offer.third2" | translate
              }}<br />{{ "home.offer.third3" | translate }}<br />
            </h3>
            <p>{{ "home.offer.button" | translate }} →</p>
          </button>
        </div>
        <div class="offer fourth-offert">
          <button
            routerLink="/offers"
            routerLinkActive="active"
            class="fourth-offer-btn"
          >
            <h3>
              {{ "home.offer.fourth1" | translate }}<br />{{
                "home.offer.fourth2" | translate
              }}<br />
            </h3>
            <p>{{ "home.offer.button" | translate }} →</p>
          </button>
        </div>
      </div>
    </div>
    <div class="offerts-btn">
      <button
        routerLink="/offers"
        routerLinkActive="active"
        class="btn-offers"
        id="btn-offerts"
      >
        {{ "home.offer.buttonAll" | translate }} →
      </button>
    </div>
  </main>
</section>
<app-contact></app-contact>
